var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3300 805.328818151858",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      maxHeight: 500
    },
    width: 3300,
    height: 805.328818151858,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(15) translate(10, 10)"
  }, /*#__PURE__*/React.createElement("defs", {
    id: "SvgjsDefs3270"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SvgjsLinearGradient3275"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00ddff",
    id: "SvgjsStop3276"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff00d4",
    id: "SvgjsStop3277"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "url(#SvgjsLinearGradient3275)",
    transform: "matrix(2.381519530542381,0,0,2.381519530542381,-2.143368940204549,-13.812813731384612)",
    id: "SvgjsG3271"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.76 18.5 c-1.28 1.1 -2.9 1.7 -4.7 1.7 c-3.64 0 -7.16 -2.96 -7.16 -7.2 s3.52 -7.2 7.16 -7.2 c1.78 0 3.38 0.6 4.64 1.66 l-1.02 1.16 c-0.98 -0.78 -2.24 -1.24 -3.5 -1.24 c-2.86 0 -5.56 2.32 -5.56 5.62 s2.7 5.62 5.56 5.62 c1.28 0 2.56 -0.48 3.54 -1.28 z M21.520000000000003 5.800000000000001 c3.64 0 7.16 2.96 7.16 7.2 s-3.52 7.2 -7.16 7.2 c-3.66 0 -7.16 -2.96 -7.16 -7.2 s3.5 -7.2 7.16 -7.2 z M21.520000000000003 18.62 c2.74 0 5.44 -2.32 5.44 -5.62 s-2.7 -5.62 -5.44 -5.62 c-2.76 0 -5.44 2.32 -5.44 5.62 s2.68 5.62 5.44 5.62 z M45.36 6 l0 14 l-1.7 0 l0 -10.28 l-4.92 10.28 l-1.36 0 l-4.9 -10.26 l0 10.26 l-1.7 0 l0 -14 l1.64 0 l5.66 11.72 l5.64 -11.72 l1.64 0 z M49.42 6 l0 14 l-1.66 0 l0 -14 l1.66 0 z M60.86000000000001 6 l0 1.56 l-3.88 0 l0 12.44 l-1.66 0 l0 -12.44 l-3.9 0 l0 -1.56 l9.44 0 z M71.38 6 l0 1.56 l-3.88 0 l0 12.44 l-1.66 0 l0 -12.44 l-3.9 0 l0 -1.56 l9.44 0 z M84.88000000000001 6 l-5.22 7.54 l0 6.46 l-1.66 0 l0 -6.46 l-5.22 -7.54 l1.9 0 l4.14 6.02 l4.16 -6.02 l1.9 0 z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    transform: "matrix(1.7467249199267547,0,0,1.7467249199267547,65.90393042924923,33.51965048043947)",
    id: "SvgjsG3272"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.94 12.3 c1.84 0.42 3.04 1.94 3.04 3.7 c0 2.46 -1.6 4 -5.06 4 l-4.72 0 l0 -14 l4.78 0 c2.74 0 4.1 1.56 4.1 3.38 c0 1.34 -0.76 2.42 -2.14 2.92 z M5.86 7.48 l-3 0 l0 4.28 l3 0 c1.6 0 2.58 -0.88 2.58 -2.16 c0 -1.32 -0.92 -2.12 -2.58 -2.12 z M5.86 18.52 c2.4 0 3.46 -0.98 3.46 -2.66 c0 -1.46 -1.06 -2.72 -3.36 -2.72 l-3.1 0 l0 5.38 l3 0 z M24.2 20 l-1.44 -3.3 l-7.48 0 l-1.44 3.3 l-1.76 0 l6.24 -14 l1.38 0 l6.26 14 l-1.76 0 z M15.899999999999999 15.3 l6.24 0 l-3.12 -7.12 z M37.84 20 l-1.8 0 l-3.54 -5.04 l-0.38 0 l-2.9 0 l0 5.04 l-1.66 0 l0 -14 l4.56 0 c3.14 0 4.96 1.92 4.96 4.52 c0 2 -1.08 3.56 -3 4.16 z M29.22 7.5600000000000005 l0 5.92 l2.86 0 c2.02 0 3.34 -1.04 3.34 -2.96 c0 -1.94 -1.32 -2.96 -3.34 -2.96 l-2.86 0 z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.eeeae2ab2b57d798d632622bf6f3fb06.svg";
export { ForwardRef as ReactComponent };